import { render, staticRenderFns } from "./petrolpending.vue?vue&type=template&id=dfb12f86&"
import script from "./petrolpending.vue?vue&type=script&lang=js&"
export * from "./petrolpending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports